fp.Component = fp.Class.extend({
    construct: function($element, config, template, parent) {
        //fp.log('construct', element[0], config, template, parent);

        this.id = _.uniqueId('c-');
        fp.Component.items[this.id] = this;

        $element = $($element);

        this.initialized = this.rendered = false;
        this.config = config = _.defaults(config, {
            enableLazyInit: false
        });
        this.scope = $.extend({}, fp.defaultScope);
        this.scope.controller = this;
        this.scope.config = config;
        this.$embeddedTemplate = S($element.prop('nodeName')).eq('script', true);
        this.size = {width: 0, height: 0};
        this.promiseQueue = {};
        this.dependencies = {
            load: {
                file: []
            }
        };

        //if(fpConfig.enableMobile && this.config.enableComponentCss) {
        //    this.dependencies.load.file.push({
        //        src: 'freshop-component.css',
        //        prepend: true
        //    });
        //
        //    this.dependencies.load.file.push('component/shared/component.html');
        //}

        if(this.$embeddedTemplate) {
            this.template = fpUi.renderTemplate($element.attr('data-id'), null, null, true);
        }
        else this.$element = $element;

        template = template || this.template || config.template || ($element.attr('data-template'));

        if (_.isString(template) && S(template).endsWith('.html')) {
            var matchLayout = template.match(fpUtil.regExp.matchLayout);
            if(_.size(matchLayout) > 1) config.layout = 'layout-' + matchLayout[1];
            template = fpUi.getTemplate(template);
        }

        this.template = config.template = template || $.noop;
        if(parent !== this) this.parent = parent;

        this.enabled = true;

        if(fp.disableRender) {
            var self = this;
            _.defer(function() {
                self.render = $.noop;
            });
        }
    },
    init: function(autoRender, options) {
        var self = this,
            config = this.config,
            prevComponent = this.$element.prev().data('fp.ui.Component'),
            promiseDependencies,
            promiseLogout;

        options = _.getObject(options);

        const deferred = $.Deferred();

        if(fp.isUnloading) return deferred.promise();
        if (!this.enabled) {
            return deferred.reject('Component has not been enabled').promise();
        }

        //turn off lazy init so that module can initialize normally
        if(config.enableLazyInit && !options.enableLazyInit && !options.force && $.isInViewport(this.$element)) {
            if(!prevComponent || (prevComponent.initialized && prevComponent.rendered)) {
                config.enableLazyInit = false;
            }
        }

        if(config.enableLazyInit && !options.force) {
            this.initialized = false;
            this.$element.removeAttr('data-loaded');
            //passing in prevComponent?.__deferredLoading allows stacked components to wait until previous component has rendered before initializing
            return $.when(prevComponent?.__deferredLoading);
        }

        this.__deferredLoading = deferred;

        if(!this.initialized) {
            if(!this.$element.length && this.elementSelector) {
                this.$element = $(this.elementSelector);
            }

            //fp.log('init', this.$element[0]);
            promiseDependencies = fpUi.loadFileDependencies(this.dependencies.load.file, {apiOptions: {apiContext: this.id}});

            this.$element.data('fp.ui.Component', this);

            if(config.requireUnauthenticated && fpUtil.isAuthenticated()) {
                promiseLogout = fp.logout();
            }
        }

        if(config.enableAnimateIn && this.rendered && this.$element.css('display') != 'none') {
            this.__$clonedElement = this.$element
                .clone()
                .removeAttr('id');

            this.$element
                .replaceWith(this.__$clonedElement)
                .appendTo(fp.__$freshop);
        }

        this.initWebCollage();

        return $.when(
            promiseDependencies,
            promiseLogout
        )
        .done(function (resp) {
            //fp.log('initialized', self.$element[0]);
            self.initialized = true;
            if(fpUtil.getBoolean(autoRender, true)) self.render();
        });
    },
    refreshData: function(autoRender) {
        //don't allow refresh data unless component has been previously rendered
        if(!this.rendered) return;

        var deferred = this.init(autoRender);
        fpUtil.showProgress(deferred);
        return deferred;
    },
    renderPlaceholder: function() {
        var promise;
        if(this.config.enableLazyInit) {
            var self = this;
            promise = this.__lazyInit()
                .done(function() {
                    //fp.log('lazy init of module', self.config.name, self);
                    self.init(true, {force: true});
                });
        }
        return $.when(promise);
    },
    render: function(params, options) {
        options = _.getObject(options);

        var config = this.config;

        //don't call render on embedded html
        if(fpUtil.isJQuery(this.template) && this?.$element[0] === this.template[0]) {
            this.$element.attr('data-fp-component', 'true');
            if(this.__deferredLoading) {
                this.__deferredLoading.resolve();
                delete this.__deferredLoading;
            }
            return;
        }

        if(!this.initialized && !options.force) {
            if(config.enableLazyInit) {
                this.renderPlaceholder();
            }
            else {
                fp.log('Error: render() called before init()', this);

                if (this.__deferredLoading) {
                    this.__deferredLoading.resolve();
                    delete this.__deferredLoading;
                }
            }
            return;
        }

        $.extend(this.scope, params);

        var self = this,
            hasOwnElement = !fpUtil.isNull(this.$element),
            template = options.template || this.template,
            html;

        try {
            html = fpUi.renderTemplate(template, this.scope, false, true);
        }
        catch(exc) {
            html = exc.toString();

            fp.notifier.notify(exc, {
                severity: 'error',
                metaData: {
                    'meta data': {
                        'Component Name': config.name,
                        'Component Selector': S.getString(config.elementSelector).substr(0, 500),
                        'Component Layout': config.layout,
                        Template: S.getString(template).substr(0, 500)
                    }
                }
            });
        }

        //if(config.enableAnimateIn && this.rendered) {
        //    $existingElement = this.__$clonedElement.clone();
        //}

        this.destroyChildComponents();

        if(hasOwnElement && !config.replaceElement) {
            //var height = this.$element.height();
            //if(height) this.$element.height(height);
            (options.$element || this.$element).html(html);
            //if(height) this.$element.css('height', '');
        }
        else {
            var $newElement = $(html);

            if(config.replaceElement) {
                this.$origElement = this.$element
                    .removeData('fp.ui.Component')
                    .replaceWith($newElement);

                $newElement.data('fp.ui.Component', this);
            }

            this.$element = $newElement;
        }

        var $element = this.$element;

        if (this.$embeddedTemplate && !hasOwnElement) {
            this.$embeddedTemplate.replaceWith($element);
        }

        if(this.rendered) $element.reflow();

        $element
            .data('fp.ui.Component', this)
            .attr('data-fp-component', 'true');

        //remove any previously added events
        $element.off();

        this.__attachScopeEvents();

        //var startDate = new Date();

        this.__resetClass();

        //if(this instanceof fp.Module.View) {
        //    var endDate = new Date(),
        //        ms = endDate - startDate,
        //        seconds = ms / 1000;
        //
        //    fp.log('****__resetClass took: ' + seconds + 's');
        //}

        if(!this.__$comment) {
            // if(!(this instanceof fp.Module)) {
            //     debugger;
            // }
            this.__$comment = $(fpUi.getComment({
                // '': fpUtil.getStateValue(this instanceof fp.Module, 'fp.Module', 'fp.Component'),
                // id: this.id,
                name: config.name,
                path: config.path,
                selector: fpUtil.getStateValue(!_.isObject(config.elementSelector), config.elementSelector)
            }))
            .insertBefore(config.enableAnimateIn && this.rendered ? this.__$clonedElement : $element);
        }

        if(config.enableAnimateIn) {
            if (this.rendered && _.size(this.__$clonedElement)) {
                $element.insertAfter(this.__$comment);
                $element.parent().css('position', 'relative');

                var position = this.$element.position();
                this.__$clonedElement
                    .addClass('fp-module-animate-out')
                    .css({
                        top: position.top,
                        marginTop: $element.css('marginTop'),
                        width: $element.width()
                    })
            }
            else {
                $element.addClass('fp-module-animate-in');
            }
        }

        if(html instanceof Error) {
            $element.addClass('hidden');
            this.rendered = false;
        }
        else if(!this.rendered) {
            //$element.children().first().removeClass('hidden');
            this.rendered = true;
        }

        this.size.width = $element.width();
        this.size.height = $element.height();

        if(this.__deferredLoading) this.__deferredLoading.resolve();

        function onRenderComplate() {
            self.initWebCollage();

            var event = $.Event(fp.events.RENDERED),
                target = _.first(self.$element);
            event.target = target;
            $(self.scope).trigger(event);
            if(!event.isDefaultPrevented()) fp.trigger(event);

            if(self instanceof fp.Module.View) {
                event = $.Event(fp.events.VIEW_MODULE_RENDERED);
                event.target = target;
                $(self.scope).trigger(event);
                if(!event.isDefaultPrevented()) fp.trigger(event);
            }
        }

        if(config.enableAnimateIn) {
            //$element
            //    .removeClass('hidden');

            if (self.rendered && _.size(self.__$clonedElement)) {
                var action = 'fadeOut';
                if (!$element.children().length) {
                    action = 'slideUp';
                    self.__$clonedElement.removeClass('fp-module-animate-out');
                }

                self.__$clonedElement[action]('normal', function () {
                    if (!self.__$clonedElement) return;

                    self.__$clonedElement.remove();
                    delete self.__$clonedElement;

                    onRenderComplate();
                });
            }
            else {
                $element
                    .removeClass('fp-module-animate-in');

                if (self.size.width * 0.5 > self.size.height) {
                    $element.fadeIn('normal', onRenderComplate);
                }
                else {
                    $element
                        .css('display', 'none')
                        .slideDown('normal', function () {
                            $element.css('display', '');

                            onRenderComplate();
                        });
                }
            }
        }
        else _.defer(onRenderComplate);
    },
    resize: function(disableRender) {
       var resize = (
           this.rendered
            && this.$element.filter(':visible').length
            && this.size.width !== this.$element.width()
        );

        //fp.log('resize', resize);
        //fp.log('visible', this.$element.filter(':visible').length);
        //fp.log('width', this.size.width, this.$element.width());

        if(resize && !disableRender) this.render();

        return resize;
    },
    busy: $.noop,
    idle: $.noop,
    disable: $.noop,
    enable: $.noop,
    enqueuePromise: function(promise) {
        if(fpUtil.isPromise(promise) && promise.state() == 'pending') {
            var self = this,
                key = _.uniqueId();
            this.promiseQueue[key] = promise
                .always(function() {
                    delete self.promiseQueue[key];
                });
        }
        return $.when(promise);
    },
    cancelQueuedPromises: function() {
        var self = this,
            hasQueued = _.size(this.promiseQueue) > 0;

        _.each(this.promiseQueue, function(item, key) {
            if(!item) return;
            if(item.state() == 'pending') {
                item.promise().deferred().reject('abort');
            }
            delete self.promiseQueue[key];
        });

        _.each(fp.apiQueue, function(item) {
            if(!item) return;
            if(item.apiContext != self.id) return;
            hasQueued = true;
            item.promise.deferred().reject('abort');
        });

        //if(hasQueued) {
        //    fp.log('cancelQueuedPromises', this);
        //}
    },
    //,cancelQueuedPromises: function() {
    //    var self = this;
    //    _.each(fp.apiQueue, function(item) {
    //        if(item.context != self.id) return;
    //        item.promise.deferred().reject('abort');
    //    });
    //},
    initWebCollage: function() {
        // const onWebCollageReady = this.config.onWebCollageReady;
        if (!(fpConfig.enableWebCollage && this.config.enableWebCollage && this.enabled)) return;

        if(window.SYNDI) {
            // if(this.rendered) _.delay(onWebCollageReady, 300);
            // else _.delay($.proxy(this.initWebCollage, this), 100);
        }
        else if(!this.__promiseWebCollage) {
            if(!fp.Component.__promiseWebCollage) {
                fp.Component.__promiseWebCollage = $.Deferred().promise();

                fpUi.loaded()
                    .then(function() {
                        //fp.log('initWebCollage');
                        return fpUi.loadScript('https://content.syndigo.com/site/b3822b36-4d2a-418f-a5cf-7c389f8b58d8/tag.js?cv=' + Math.floor(Date.now() / 86400000));
                    })
                    .always(function () {
                        fp.Component.__promiseWebCollage.deferred().resolve();
                        delete fp.Component.__promiseWebCollage;
                    });
            }

            this.__promiseWebCollage = fp.Component.__promiseWebCollage;

            // var self = this;
            // this.__promiseWebCollage = fp.Component.__promiseWebCollage
            //     .then(function() {
            //         if(window.SYNDI) self.initWebCollage();
            //     });
        }
    },
    destroy: function(persistUI) {
        if(this.__promiseWebCollage) this.__promiseWebCollage.deferred().reject();

        this.destroyChildComponents(persistUI);

        this.initialized = this.rendered = false;

        $(this.scope).off();

        delete fp.Component.items[this.id];

        //fp.log('destroy', this.id, this.$element[0]);

        this.cancelQueuedPromises();

        this.__prepareForDestroy();

        if(!this.$element) return;

        this.$element
            .off()
            .removeData('fp.ui.Component')
            .removeAttr('data-fp-component');
            
        if(this.__$comment) this.__$comment.remove();

        if(persistUI) return;

        this.__resetClass(true);

        //don't alter html for embedded template
        if (fpUtil.isJQuery(this.template) && this.$element && this.$element[0] == this.template[0]) {
            return;
        }

        if (this.$embeddedTemplate) this.$element.replaceWith(this.$embeddedTemplate);
        else this.$element.empty();
    },
    destroyChildComponents: function(persistUI) {
        if(this.rendered) {
            fp.Component.destroyChildComponents(persistUI, this.$element);
        }
    },
    __lazyInit: function() {
        var deferred = $.Deferred();
        fp.lozad(this.$element[0], {
            load: deferred.resolve
        }).observe();

        return deferred.promise();
    },
    __attachScopeEvents: function() {
        var self = this,
            $scope = $(this.scope).off(),
            storeId = fp.store.id;

        $scope
            .on(fp.events.INITIALIZE, function (event, payload) {
                self.init(true);
            })
            .on(fp.events.ROUTE_BEFORE_CHANGE, function (event, payload) {
                if (!payload.fromState.abstract && payload.fromState != payload.toState) {
                    self.cancelQueuedPromises();
                    return;
                }
            })
            .on(fp.events.STORE_CHANGED, function (event, payload) {
                if(S(storeId).ne(fp.store.id)) {
                    storeId = fp.store.id;
                    if(self.initialized && self.config.initializeOnStoreChange) self.init(true);
                    else if(self.config.renderOnStoreChange) self.render();
                }
            });

        _.each(this.config.refreshDataTriggers, function(item, key) {
            key = S(key).dasherize('_').toUpperCase().s;
            if(!_.has(fp.events, key)) return;

            $scope
                .on(fp.events[key], function(event, payload) {
                    payload = _.getObject(payload);
                    if(!payload.rendered) return;
                    if(!payload.name) return;
                    if(!_.contains(item, payload.name)) return;

                    self.refreshData();
                });
        });
    },
    __resetClass: function(remove) {
        this.$element.replaceClass(fpUtil.regExp.matchLayoutClass, '');
        if(!remove) {
            this.$element.addClass(fpUtil.formatString('fp-{0}', S.getString(this.config.layout, 'layout-0')));
        }
    },
    __prepareForDestroy: function() {
        delete this.parent;
        var scope = this.scope;

        if(_.isObject(scope)) {
            delete scope.controller;

            for(var key in scope) {
                if(_.isFunction(scope[key])) scope[key] = $.noop;
            }
        }
        for(var key in this) {
            if(_.isFunction(this[key])) this[key] = $.noop;
        }
        this.init = this.enqueuePromise = function() {
            return $.when();
        };


    }
});

$.extend(fp.Component, {
    items: {},
    parseHtml: function(html, enableModules) {
        var returnValue = {};
        returnValue.html = S(html).trim().s;
        if(!html) return returnValue;

        var regExp = fpUtil.regExp,
            matchDataId = regExp.matchDataId,
            attrs,
            template,
            id,
            matches;

        //replace occurances of pattern type="text/fp-template" or type="text/template" with an empty string and cache the template
        regExp.matchFreshopTemplate.lastIndex = 0;
        html = html.replace(regExp.matchFreshopTemplate, function(match, $1, $2, $3, $4, $5) {
            attrs = $2;
            template = $5;

            matchDataId.lastIndex = 0;
            if(attrs) matches = attrs.match(matchDataId);

            id = matches && matches.length > 2 ? matches[2] : 'undefined';

            // fp.log('cacheTemplate', id);
            //cacheTemplate(id, _.template(template));
            fpUi.cacheTemplate(id, template);

            return '';
        });

        //replace occurances of pattern data-render-template="template/path/name.html" with the call for the specific template method
        //regExp.matchDataTemplate.lastIndex = 0;
        //html = html.replace(regExp.matchDataTemplate, function(match, $1, $2, $3) {
        //    // fp.log('renderTemplate', $3);
        //    return '<%= fp.ui.renderTemplate("' + $3 + '", obj) %>';
        //});

        if(enableModules) {
            var modules = [],
                dataModule,
                config;
            //find any occurrances of data-module="path/moduleName"
            regExp.matchDataModule.lastIndex = 0;
            html.replace(regExp.matchDataModule, function (match, $1, $2) {
                attrs = fpUtil.attrParams($2, ' ');
                config = attrs['data-module-config'];

                if (S(config).startsWith('{')) config = JSON.parse(config);
                if (!config) {
                    dataModule = S.getString(attrs['data-module']);
                    config = {
                        name: dataModule,
                        selector: (attrs['data-role'] && fpUtil.formatString('[data-role="{0}"]', attrs['data-role'])) || (dataModule && fpUtil.formatString('[data-module="{0}"]', dataModule))
                    };
                }

                modules.push(config);
            });

            if(_.size(modules)) returnValue.modules = modules;
        }

        returnValue.html = S(html).trim().s;

        return returnValue;
    },
    trigger: function(selector, event, data) {
        var component;
        if(selector) {
            var eventNs = fpUtil.getEventNs(event),
                enableLoad = eventNs == fp.events.MODULE_LOAD,
                $element = $(selector);

            if(
                !enableLoad &&
                eventNs == fp.events.INITIALIZE &&
                $element.length &&
                !$element.data('fp.ui.Component')
            ) {
                enableLoad = true;
            }

            if(enableLoad) {
                var promise;
                if(fp.loaded) promise = fp.Module.__loadModule(selector);
                if(data && _.isFunction(data.callback)) {
                    if(!fp.loaded) {
                        promise = $.Deferred().promise();
                        fp.one(fp.events.LOADED, promise.deferred().resolve)
                    }
                    promise.always(data.callback);
                }
                return;
            }

            component = $element.data('fp.ui.Component');
            //fp.log('Trigger client event', selector, component);
        }

        if(component instanceof fp.Component) {
            //fp.log('Trigger client event', selector, component);
            $(component.scope).trigger(event, data);
            return;
        }

        //don't use _.each as it creates anonymous functions
        //which ends up not triggering event at correct time
        var item;
        for(var key in this.items) {
            item = this.items[key];
            $(item.scope).trigger(event, data);
        }
    },
    off: function(selector, event, callback) {
        var component;

        if(selector) component = $(selector).data('fp.ui.Component');

        if(component instanceof fp.Component) {
            $(component.scope).off(event, callback);
            return;
        }

        _.each(this.items, function(item) {
            $(item.scope).off(event, callback);
        });
    },
    destroyChildComponents: function(persistUI, selector, allowModuleDestroy) {
        $(selector).find('[data-fp-component="true"]')
            .each(function() {
                const component = $(this).data('fp.ui.Component');
                if(component && component.config?.allowComponentDestroy !== false && (!(component instanceof fp.Module) || allowModuleDestroy)) {
                    component.destroy(fpUtil.getBoolean(persistUI, true));
                }
            });
    }
});